(() => {
  const colours = { cream: '#fff8f2', blush: '#f4e4e2', lilac: '#eee8f5' };
  const berry = '#7a3048';
  function start(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-mug-config]').textContent);
    const text = config.strings;
    function measure(name,extra={}){
      document.dispatchEvent(new CustomEvent('whb:gift-event',{detail:{name,...config.measurement,value:Number(config.measurement?.price)/100,...extra}}));
    }
    measure('gift_viewed');
    let started=false;
    const find = selector => root.querySelector(selector);
    const all = selector => [...root.querySelectorAll(selector)];
    const preview = find('[data-mug-preview]');
    const dialog = find('[data-review-dialog]');
    const review = find('[data-review-canvas]');
    const cropCanvas = find('[data-crop-canvas]');
    const artwork = document.createElement('canvas');
    artwork.width = Math.round(config.width * 300);
    artwork.height = Math.round(config.height * 300);
    const state = {
      photos: [null], sample: null, mugTemplate: null, crops: [{ zoom: 1, x: .5, y: .5 }],
      loading: [false], uploadVersions: [0], style: 'photo_text', colour: 'white', view: 'front',
      names: '', message: '', active: 0, step: 0, version: 0, approvedVersion: -1, busy: false
    };
    function showError(message, reviewError = false) {
      const element = find(reviewError ? '[data-review-error]' : '[data-mug-error]');
      element.textContent = message;
      element.hidden = !message;
    }
    function photoAt(index) {
      return state.photos[index];
    }
    function cropAt(index) {
      return state.crops[index];
    }
    function cropSource(image, width, height, crop) {
      const scale = Math.max(width / image.naturalWidth, height / image.naturalHeight) * crop.zoom;
      const sourceWidth = width / scale;
      const sourceHeight = height / scale;
      return [(image.naturalWidth - sourceWidth) * crop.x, (image.naturalHeight - sourceHeight) * crop.y, sourceWidth, sourceHeight];
    }
    function quality() {
      if (state.loading.some(Boolean)) return 'loading';
      if (!photoAt(0)) return 'sample';
      const dpi = [0].map(index => {
        const width = 1000;
        const height = 700;
        const source = cropSource(photoAt(index).image, width, height, cropAt(index));
        return Math.min(source[2] / (config.width * width / 2700), source[3] / (config.height * height / 1050));
      });
      return Math.min(...dpi) < 150 ? 'low' : Math.min(...dpi) < 300 ? 'ok' : 'good';
    }
    function updateQuality() {
      const level = quality();
      const message = level === 'loading' ? text.loading : level === 'sample' ? text.sample_help : text['quality_' + level];
      find('[data-quality]').textContent = message;
      find('[data-quality]').dataset.level = level;
      return level;
    }
    function rounded(ctx, x, y, w, h, r) {
      ctx.beginPath(); ctx.roundRect(x, y, w, h, r);
    }
    function drawArtwork() {
      const ctx = artwork.getContext('2d');
      ctx.save(); ctx.clearRect(0, 0, artwork.width, artwork.height);
      ctx.scale(artwork.width / 2700, artwork.height / 1050);
      const selected = photoAt(0);
      const image = selected?.image || state.sample;
      const crop = selected ? cropAt(0) : { zoom: 1, x: .4, y: .15 };
      const box = { x: 175, y: 90, w: 1000, h: 700 };
      if (image) {
        const source = cropSource(image, box.w, box.h, crop);
        ctx.save(); rounded(ctx, box.x, box.y, box.w, box.h, 4); ctx.clip();
        ctx.drawImage(image, ...source, box.x, box.y, box.w, box.h); ctx.restore();
      }
      const message = state.message || (!selected ? text.sample_bottom_text : '');
      ctx.fillStyle = berry; ctx.textAlign = 'center'; ctx.font = '52px Georgia,serif';
      const words = message.split(/\s+/).filter(Boolean);
      const lines = []; let line = '';
      words.forEach(word => {
        const next = line ? line + ' ' + word : word;
        if (line && ctx.measureText(next).width > 1100) { lines.push(line); line = word; }
        else line = next;
      });
      if (line) lines.push(line);
      lines.slice(0, 2).forEach((value, index) => ctx.fillText(value, 675, 900 + index * 70, 1100));
      ctx.restore();
    }
    function bodyPath(ctx) {
      ctx.beginPath(); ctx.moveTo(205, 198); ctx.bezierCurveTo(205, 172, 665, 172, 665, 198);
      ctx.lineTo(652, 592); ctx.bezierCurveTo(650, 642, 219, 642, 218, 592); ctx.closePath();
    }
    function drawMug(ctx) {
      ctx.save();
      if (state.mugTemplate) {
        ctx.translate(-325.6, -406); ctx.scale(1.6, 1.6);
        ctx.beginPath(); ctx.moveTo(554, 400);
        ctx.bezierCurveTo(614, 390, 658, 423, 658, 486);
        ctx.bezierCurveTo(659, 544, 618, 584, 554, 582); ctx.lineTo(554, 555);
        ctx.bezierCurveTo(600, 558, 630, 530, 631, 488);
        ctx.bezierCurveTo(632, 449, 606, 424, 554, 426); ctx.closePath();
        const handle = ctx.createLinearGradient(554, 0, 658, 0);
        handle.addColorStop(0, '#e7e7e7'); handle.addColorStop(.5, '#fdfdfd'); handle.addColorStop(1, '#e7e7e7');
        ctx.fillStyle = handle; ctx.fill();
        ctx.beginPath(); ctx.moveTo(342, 363);
        ctx.bezierCurveTo(395, 354, 510, 354, 557, 361);
        ctx.lineTo(557, 618); ctx.bezierCurveTo(514, 635, 384, 635, 342, 618); ctx.closePath();
        ctx.clip(); ctx.drawImage(state.mugTemplate, 0, 0);
        ctx.globalCompositeOperation = 'multiply';
        ctx.drawImage(artwork, 0, 0, artwork.width / 2, artwork.height, 342, 390, 215, 200);
      } else {
        ctx.fillStyle = '#f7f7f7'; ctx.fillRect(220, 170, 347, 430);
        ctx.drawImage(artwork, 0, 0, artwork.width / 2, artwork.height, 220, 218, 344, 320);
      }
      ctx.restore();
    }
    function drawPreview() {
      drawArtwork();
      const ctx = preview.getContext('2d'); ctx.clearRect(0, 0, preview.width, preview.height);
      drawMug(ctx);
      const personal = !!state.photos[0];
      find('[data-sample-label]').textContent = personal ? text.personal_view.toUpperCase() : text.sample_label;
      find('[data-view-caption]').textContent = text.front;
      if (dialog.open) { drawReview(); drawCrop(); }
    }
    function drawReview() {
      const ctx = review.getContext('2d'); ctx.clearRect(0, 0, review.width, review.height);
      ctx.save(); ctx.scale(review.width / 900, review.width / 900); drawMug(ctx); ctx.restore();
      ctx.fillStyle = berry; ctx.font = '24px Arial'; ctx.textAlign = 'center'; ctx.fillText(text.front, review.width / 2, review.height - 24);
    }
    function cropFrame() {
      const ratio = 1000 / 700;
      const width = 540; const height = width / ratio;
      return { x: (720 - width) / 2, y: (600 - height) / 2, width, height };
    }
    function drawCrop() {
      const ctx = cropCanvas.getContext('2d'); ctx.clearRect(0, 0, 720, 600);
      ctx.fillStyle = '#292326'; ctx.fillRect(0, 0, 720, 600);
      const photo = photoAt(0); if (!photo) return;
      const image = photo.image; const crop = cropAt(0); const frame = cropFrame();
      const scale = Math.max(frame.width / image.naturalWidth, frame.height / image.naturalHeight) * crop.zoom;
      const width = image.naturalWidth * scale; const height = image.naturalHeight * scale;
      ctx.drawImage(image, frame.x - (width - frame.width) * crop.x, frame.y - (height - frame.height) * crop.y, width, height);
      ctx.fillStyle = '#120c16a8'; ctx.beginPath(); ctx.rect(0, 0, 720, 600); ctx.rect(frame.x, frame.y, frame.width, frame.height); ctx.fill('evenodd');
      ctx.strokeStyle = '#ffffff'; ctx.lineWidth = 4; ctx.strokeRect(frame.x, frame.y, frame.width, frame.height);
      ctx.strokeStyle = '#ffffff80'; ctx.lineWidth = 1;
      for (let n = 1; n < 3; n++) { ctx.beginPath(); ctx.moveTo(frame.x + frame.width * n / 3, frame.y); ctx.lineTo(frame.x + frame.width * n / 3, frame.y + frame.height); ctx.stroke(); ctx.beginPath(); ctx.moveTo(frame.x, frame.y + frame.height * n / 3); ctx.lineTo(frame.x + frame.width, frame.y + frame.height * n / 3); ctx.stroke(); }
    }
    let drag = null;
    cropCanvas.addEventListener('pointerdown', event => {
      if (!photoAt(0) || state.loading[0]) return;
      const rect = cropCanvas.getBoundingClientRect();
      drag = { pointerId: event.pointerId, x: event.clientX, y: event.clientY, crop: { ...cropAt(0) }, scaleX: 720 / rect.width, scaleY: 600 / rect.height };
      cropCanvas.setPointerCapture(event.pointerId);
    });
    cropCanvas.addEventListener('pointermove', event => {
      if (!drag || drag.pointerId !== event.pointerId) return;
      const image = photoAt(0).image; const frame = cropFrame();
      const scale = Math.max(frame.width / image.naturalWidth, frame.height / image.naturalHeight) * drag.crop.zoom;
      const overflowX = image.naturalWidth * scale - frame.width; const overflowY = image.naturalHeight * scale - frame.height;
      const clamp = value => Math.max(0, Math.min(1, value));
      state.crops[0].x = overflowX > 0 ? clamp(drag.crop.x - (event.clientX - drag.x) * drag.scaleX / overflowX) : .5;
      state.crops[0].y = overflowY > 0 ? clamp(drag.crop.y - (event.clientY - drag.y) * drag.scaleY / overflowY) : .5;
      all('[data-crop-control]').forEach(control => { control.value = state.crops[0][control.dataset.cropControl]; }); changed();
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => cropCanvas.addEventListener(type, () => { drag = null; }));
    find('[data-rotate]').addEventListener('click', async () => {
      const photo = photoAt(0); if (!photo || state.loading[0]) return;
      state.loading[0] = true; updateQuality(); updateOrderButton();
      let url = '';
      try {
        const rotation = (photo.rotation + 90) % 360; const image = photo.originalImage;
        const rotated = document.createElement('canvas'); const swapped = rotation % 180 !== 0;
        rotated.width = swapped ? image.naturalHeight : image.naturalWidth; rotated.height = swapped ? image.naturalWidth : image.naturalHeight;
        const ctx = rotated.getContext('2d'); ctx.translate(rotated.width / 2, rotated.height / 2); ctx.rotate(rotation * Math.PI / 180); ctx.drawImage(image, -image.naturalWidth / 2, -image.naturalHeight / 2);
        url = URL.createObjectURL(await toBlob(rotated)); const next = new Image(); next.src = url; await next.decode();
        if (state.photos[0] !== photo) { URL.revokeObjectURL(url); return; }
        if (photo.rotatedUrl) URL.revokeObjectURL(photo.rotatedUrl);
        photo.image = next; photo.rotatedUrl = url; photo.rotation = rotation;
        state.loading[0] = false; state.crops[0] = { zoom: 1, x: .5, y: .5 }; changed(); edit(0);
      } catch {
        if (url) URL.revokeObjectURL(url);
        if (state.photos[0] === photo) { state.loading[0] = false; showError(text.bad_image); updateQuality(); updateOrderButton(); }
      }
    });
    function updateOrderButton() {
      find('[data-order]').disabled = !config.enabled || !find('[data-approve]').checked || state.approvedVersion !== state.version || quality() === 'low' || state.busy;
    }
    function changed() {
      state.version++; state.approvedVersion = -1; find('[data-approve]').checked = false;
      showError(''); showError('', true); updateQuality(); drawPreview(); updateOrderButton();
    }
    function edit(index) {
      if (!state.photos[index]) return;
      state.active = index; find('[data-crop]').hidden = false;
      find('[data-crop-title]').textContent = text.photo + ' ' + (index + 1);
      all('[data-crop-control]').forEach(control => control.value = state.crops[index][control.dataset.cropControl]);
      state.view = 'front';
      all('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === state.view)));
      drawPreview();
    }
    all('[data-photo]').forEach(input => input.addEventListener('change', async () => {
      const index = Number(input.dataset.photo);
      const file = input.files[0]; if (!file) return;
      showError('');
      const fail = message => { input.value = ''; showError(message); };
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return fail(text.bad_type);
      if (file.size > 15 * 1024 * 1024) return fail(text.bad_size);
      const version = ++state.uploadVersions[index]; state.loading[index] = true; updateQuality();
      const url = URL.createObjectURL(file);
      try {
        const image = new Image(); image.src = url; await image.decode();
        if (version !== state.uploadVersions[index]) { URL.revokeObjectURL(url); return; }
        if (image.naturalWidth * image.naturalHeight > 40000000) throw new Error('large');
        if (state.photos[index]) { URL.revokeObjectURL(state.photos[index].url); if (state.photos[index].rotatedUrl) URL.revokeObjectURL(state.photos[index].rotatedUrl); }
        state.photos[index] = { image, originalImage: image, file, url, rotation: 0, rotatedUrl: '' };
        find('[data-upload-thumbnail]').src = url; find('[data-upload-thumbnail]').hidden = false;
        state.crops[index] = { zoom: 1, x: .5, y: .5 };
        find('[data-filename="' + index + '"]').textContent = file.name;
        find('[data-upload-card="' + index + '"]').classList.add('has-photo');
        find('[data-edit="' + index + '"]').hidden = false;
        state.loading[index] = false; measure('photo_uploaded'); changed(); edit(index);
      } catch (error) {
        URL.revokeObjectURL(url); state.loading[index] = false;
        fail(error.message === 'large' ? text.too_large : text.bad_image); updateQuality();
      }
    }));
    all('[data-edit]').forEach(button => button.addEventListener('click', () => { edit(Number(button.dataset.edit)); setStep(1); }));
    all('[data-crop-control]').forEach(input => input.addEventListener('input', () => {
      state.crops[state.active][input.dataset.cropControl] = Number(input.value); changed();
    }));
    find('[data-reset]').addEventListener('click', () => { const photo = state.photos[0]; if (photo) { photo.image = photo.originalImage; photo.rotation = 0; if (photo.rotatedUrl) URL.revokeObjectURL(photo.rotatedUrl); photo.rotatedUrl = ''; } state.crops[0] = { zoom: 1, x: .5, y: .5 }; changed(); edit(0); });
    find('[data-message]').addEventListener('input', event => {
      state.message = event.target.value.trim();
      find('[data-message-count]').textContent = event.target.value.length + ' / 45'; changed();
    });
    all('[data-view]').forEach(button => button.addEventListener('click', () => {
      state.view = button.dataset.view; all('[data-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button))); drawPreview();
    }));
    function setStep(step) {
      state.step = step;
      all('[data-editor-step]').forEach(element => { element.hidden = Number(element.dataset.editorStep) !== step; });
      all('[data-step-indicator]').forEach(element => element.setAttribute('aria-current', Number(element.dataset.stepIndicator) === step ? 'step' : 'false'));
      find('[data-step-back]').hidden = step === 0;
      find('[data-step-next]').hidden = step === 2;
      find('[data-step-next]').textContent = step === 1 ? text.apply : text.next;
      showError(''); showError('', true);
      find('.mug-drawer-body').scrollTop = 0;
      if (step === 1) drawCrop();
      if (step === 2) {
        const level = updateQuality();
        drawReview(); find('[data-review-summary]').textContent = state.message || text.no_message;
        find('[data-low-quality]').hidden = level === 'good'; find('[data-low-quality]').textContent = text['quality_' + level] || '';
        find('[data-launch-detail]').hidden = config.enabled;
        find('[data-order]').hidden = !config.enabled;
        find('[data-approve]').checked = false; state.approvedVersion = -1; updateOrderButton();
      }
    }
    all('[data-review]').forEach(button => button.addEventListener('click', () => {
      state.approvedVersion = -1; find('[data-approve]').checked = false; updateOrderButton();
      if(!started){started=true;measure('customization_started');}
      setStep(0); dialog.showModal();
    }));
    find('[data-step-next]').addEventListener('click', () => {
      if (!photoAt(0) || state.loading.some(Boolean)) { showError(text.need_photos); return; }
      if (state.step === 0) { edit(0); setStep(1); } else setStep(2);
    });
    find('[data-step-back]').addEventListener('click', () => setStep(Math.max(0, state.step - 1)));
    find('[data-edit-design]').addEventListener('click', () => { edit(0); setStep(1); });
    find('[data-approve]').addEventListener('change', event => { state.approvedVersion = event.target.checked ? state.version : -1;if(event.target.checked)measure('design_approved'); updateOrderButton(); });
    find('[data-close-review]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
    function toBlob(canvas, type = 'image/png') {
      return new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('export')), type, .95));
    }
    find('[data-download]').addEventListener('click', async () => {
      try {
        const blob = await toBlob(review); const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a'); anchor.href = url; anchor.download = 'wishhappybday-mug-preview.png'; anchor.click();
        setTimeout(() => URL.revokeObjectURL(url), 30000);
      } catch { showError(text.download_error, true); }
    });
    async function png300(blob) {
      const bytes = new Uint8Array(await blob.arrayBuffer());
      const data = new Uint8Array(9); const view = new DataView(data.buffer); view.setUint32(0, 11811); view.setUint32(4, 11811); data[8] = 1;
      const chunk = new Uint8Array(21); new DataView(chunk.buffer).setUint32(0, 9); chunk.set([112, 72, 89, 115], 4); chunk.set(data, 8);
      let crc = 0xffffffff; for (const byte of chunk.subarray(4, 17)) { crc ^= byte; for (let i = 0; i < 8; i++) crc = crc & 1 ? (crc >>> 1) ^ 0xedb88320 : crc >>> 1; }
      new DataView(chunk.buffer).setUint32(17, (crc ^ 0xffffffff) >>> 0);
      const parts = [bytes.subarray(0, 33), chunk];
      for (let offset = 33; offset < bytes.length;) {
        const length = new DataView(bytes.buffer, bytes.byteOffset + offset, 4).getUint32(0);
        const type = String.fromCharCode(...bytes.subarray(offset + 4, offset + 8));
        if (type !== 'pHYs') parts.push(bytes.subarray(offset, offset + length + 12));
        offset += length + 12;
      }
      return new Blob(parts, { type: 'image/png' });
    }
    find('[data-order]').addEventListener('click', async () => {
      const form = find('.mug-order-form');
      if (!config.enabled || !form || !photoAt(0) || state.approvedVersion !== state.version || quality() === 'low' || !find('[data-approve]').checked || state.busy) return;
      state.busy = true; updateOrderButton(); showError('', true); find('[data-order]').textContent = text.adding;
      try {
        const version = state.version; drawArtwork(); drawReview();
        const [art, proof] = await Promise.all([toBlob(artwork).then(png300), toBlob(review)]);
        if (version !== state.version) throw new Error('changed');
        const id = 'M' + crypto.randomUUID().replaceAll('-', '').slice(0, 14);
        [[find('[data-art-file]'), art, id + '-print.png'], [find('[data-proof-file]'), proof, id + '-approved.png']].forEach(([input, blob, filename]) => {
          const transfer = new DataTransfer(); transfer.items.add(new File([blob], filename, { type: 'image/png' })); input.files = transfer.files;
        });
        find('[data-prop-names]').value = state.names; find('[data-prop-message]').value = state.message;
        find('[data-prop-style]').value = text.photo_text_layout; find('[data-design-id]').value = id;
        measure('gift_add_requested',{design_id:id});
        HTMLFormElement.prototype.submit.call(form);
      } catch { showError(text.order_error, true); state.busy = false; updateOrderButton(); find('[data-order]').textContent = text.add_to_bag; }
    });
    const mugTemplate = new Image(); mugTemplate.crossOrigin = 'anonymous'; mugTemplate.onload = () => { state.mugTemplate = mugTemplate; drawPreview(); }; mugTemplate.onerror = () => showError(text.bad_image); mugTemplate.src = config.mug_template;
    const sample = new Image(); sample.crossOrigin = 'anonymous'; sample.onload = () => { state.sample = sample; drawPreview(); }; sample.onerror = () => showError(text.bad_image); sample.src = config.sample;
    drawPreview();
  }
  function init() { document.querySelectorAll('[data-whb-mug]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

